export default __webpack_public_path__ + "static/media/table.207ebe4d.png";